const getDecoders = contexts => contexts.map(({ key, queryDecoder }) => [key, queryDecoder]);

export default getDecoders;
